/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useState,memo, useRef } from 'react';
import DateRange from '../../../../components/TopBar/DateRange';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import DropDownComponent from './Dropdown';
import DateRangeForDropDown from './DateRangeForDropdown'; 
const Filter = ({
    FilterData, radioButton,
    dateRangeFilterName,FilterCheckbox, 
    setSelectedDateRange,selectedDateRange,
    setEndDate,setStartDate,
    handleApplyFilter, selectedName,
    setIsFilterOpen,handleSelectObject,
    selectedFilter, setSelectedFilter,
    tooltip,  filterCount, setFilterCheckBox,
    currentFinacialYear,academicYears,calculateEndDate,
    setSelectedName,searchParams,
    setSearchParams,finacialYear,ref}) => {

    const [selectedDates, setSelectedDates] = useState({})
    const [dateErrorMsg,setDateErrorMsg] = useState('')


    /**
     * The function `handleCheck` checks if the end date is earlier than the start date.
     * @returns The function `handleCheck` returns a boolean value indicating whether the `endDate` is less
     * than the `startDate`.
     */
    const handleCheck = () => {
        const startDate_1 = new Date(FilterCheckbox['start_date']);
        const endDate_2 = new Date(FilterCheckbox['end_date']);
        // Convert startDate and endDate to UTC
        let startDate = startDate_1.toDateString().split('00:')[0]
        let endDate = endDate_2.toDateString().split('00:')[0]

        if(selectedDateRange === 'Custom' && selectedFilter ==='date_range'){
            if(FilterCheckbox['start_date']===null || FilterCheckbox['end_date']===null) {
                if(FilterCheckbox['start_date']===null && FilterCheckbox['end_date']===null){
                    return false;
                } else if ((selectedDates.start_date === undefined || searchParams.get('start_date') === null ) || (selectedDates.end_date === undefined || searchParams.get('end_date') === null)){
                    setdateError(true)
                    setDateErrorMsg('Both start date and end date are required.')
                    return true;
                }
                
            } else if ( (searchParams.get('dropname') === 'Academic Year' || searchParams.get('dropname') === 'Financial Year') && (selectedDates.start_date === undefined || selectedDates.end_date === undefined ) ) {
                setDateErrorMsg('Both start date and end date are required.')
                return true
            } else if (new Date(endDate) < new Date(startDate)) {
                if(new Date(endDate) === new Date(startDate)) {
                    return false
                } else {
                    setDateErrorMsg('Start Date cannot exceed End Date')
                    return true       
                }
            } else {
                return false
            }
        } else {
            return false
        }

    }
    const closeRef = useRef();
    /* The `useOnClickOutside` hook is a custom hook that is used to detect clicks outside of a specified
    element. In this case, it is used to detect clicks outside of the filter component. */
    useOnClickOutside(closeRef, () => {
        setIsFilterOpen(false)
    })

    /**
     * The function `handleInputValue` takes in an item and a type, and returns a formatted value based on
     * the selected filter and item.
     * @returns The function `handleInputValue` returns the value of the `value` variable.
     */
    const handleInputValue = (item, type) => {
        let value = ""
        {selectedFilter === "status" ? item === 'true' ? 'Active' : item === 'false' ? 'Inactive' : (item === "fee" && selectedFilter === "invoice_type") ? "Fee Invoice" : (item === "inventory" && selectedFilter === "invoice_type") ? "Inventory Invoice" : item : item?.length>50 ?`${item.substring(0, 12)}...`: item}
        switch (item) {
        case "true":
            if(selectedFilter === "status") {
                value = 'Active'
            }
            break;
        case "false":
            if(selectedFilter === "status") {
                value = 'Inactive'
            }
            break;
        case "fee":
            if(selectedFilter === "invoice_type") {
                value = 'Fee Invoice'
            }
            break;
        case "inventory":
            if(selectedFilter === "invoice_type") {
                value = 'Inventory Invoice'
            }
            break;
        
        default:
            break;
        }
        if(value === "") {
            value = item
        }
        return type === "tool_tip" ? value : value?.length>50 ?`${value.substring(0, 12)}...`: value
    }
        
    const [dateError, setdateError] = useState(false)

    return (
        <div class={`filter_btn_drp_dwn top3 ${filterCount ===0 ? '' : 'filterCnt'} shadow-s1 filter_modal`} ref={closeRef} style={{'width':'345px'}}>
            <div class="flex h-[80%]">
                <ul class="flex list-none flex-col flex-wrap h-fit filter_btn_drp_dwn_div1 min-w-[95px]" role="tablist" data-te-nav-ref="">
                    {Object.keys(FilterData).map((item, index) => (
                        <li role="presentation" class="flex-grow text-center" key={item}>
                            <button id={item} data-test-id={index+item}
                                onClick={() => {
                                    setSelectedFilter(item); 
                                    setdateError(false)
                                }}  
                                class={`${dateRangeFilterName !== undefined ? "min-w-[130px] text-start text-sm font-normal" : "text-start relative block text-sm font-normal "} ${selectedFilter === item ? " text-[#106EB4]" : "text-[#4D555B]"} mb-3`}>{dateRangeFilterName === undefined ? item.replace(/_/g, ' ').toLowerCase().replace(/(?:^|\s)\S/g, function(c) { return c.toUpperCase(); }) : dateRangeFilterName}</button>
                        </li>))}
                </ul>
                <div class={selectedFilter !== "date_range" ? "filter_btn_drp_dwn_div2" : "filter_btn_drp_dwn_div2"}>
                    <div class="hidden transition-opacity duration-150 ease-linear data-[te-tab-active]:block opacity-100" id="tabs-home03" role="tabpanel" aria-labelledby="tabs-home-tab03" data-te-tab-active="">
                        <div class="h-[220px] overflow-auto overflow-x-hidden scroll-smooth scroll-bar">
                            <div class={"w-full"}>
                                {(selectedFilter !== "date_range" && selectedFilter !== "custom")? FilterData[selectedFilter]?.length === 0 ? 
                                    <div className='text-[13px] text-center pt-[35px]'>
                                        {"No options available."}
                                    </div> 
                                    : FilterData[selectedFilter]?.map((item) => (
                                        ((radioButton !== undefined && radioButton) ?
                                            <div key={item._id} onChange={(e) => {
                                                handleSelectObject(item,'',selectedFilter)}} className="relative custom-radioBlue mb-3 flex items-center">
                                                <input
                                                    type='radio'
                                                    id={item} 
                                                    name="radio"
                                                    autocompleted={item} 
                                                    checked={FilterCheckbox[selectedFilter]?.includes(item)===true} 
                                                    onChange={(e) => {
                                                        handleSelectObject(item,'',selectedFilter)}}
                                                />
                                                <label 
                                                    title={handleInputValue(item, "tool_tip")} 
                                                    htmlFor={item} 
                                                    name="radio"
                                                    
                                                >{item}</label>
                                            </div>
                                            :
                                            <div class={`relative checkbox custom-checkBoxBlue1 mb-3 more-lines flex ${item?.length > 12 ? 'line-wrap' : ''}`} key={item}>
                                                <input 
                                                    type="checkbox" 
                                                    id={item} 
                                                    autocompleted={item} 
                                                    checked={FilterCheckbox[selectedFilter]?.includes(selectedFilter === "status" ? item.toLowerCase() : item)} 
                                                    onChange={(e) => handleSelectObject(selectedFilter === "status" ? item.toLowerCase() : item,'',selectedFilter)}
                                                />
                                                <label 
                                                    title={handleInputValue(item, "tool_tip")} 
                                                    htmlFor={item} 
                                                    
                                                >{handleInputValue(item)}</label>
                                            </div>)
                                    ))
                                    :<div className='-mt-1'>
                                        <DateRangeForDropDown 
                                            dateErrorMsg={dateErrorMsg}
                                            searchParams={searchParams}
                                            setSearchParams={setSearchParams} 
                                            selectedName={selectedName}
                                            setSelectedName={setSelectedName}
                                            finacialYear={finacialYear} 
                                            selectedDateRange={selectedDateRange}
                                            setSelectedDateRange={setSelectedDateRange}
                                            filterCount={filterCount}
                                            academicYears={academicYears}
                                            currentFinacialYear={currentFinacialYear}
                                            setSelectedDates={setSelectedDates} 
                                            dateError={dateError} 
                                            setEndDate={setEndDate}
                                            setStartDate={setStartDate}
                                            setdateError={setdateError} 
                                            handleCheck={handleCheck} 
                                            setFilterCheckBox={setFilterCheckBox}
                                            handleSelectObject={handleSelectObject} 
                                            setIsFilterOpen={setIsFilterOpen} 
                                            FilterCheckbox={FilterCheckbox}
                                            calculateEndDate={calculateEndDate} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center pt-[10px] mt-1 shadow-top">
                <button type="button"  onClick={()=>{
                    handleApplyFilter(false); 
                    setIsFilterOpen(false)}} class="clr-btn">Clear All
                </button>
                <button onClick={()=>{
                    if(handleCheck()){
                        setdateError(true)
                        return
                    } else if (selectedDateRange === 'Custom' && selectedFilter ==='date_range' && (FilterCheckbox['start_date']===null || FilterCheckbox['end_date']===null)) {
                        if(selectedDates.start_date === undefined || selectedDates.end_date === undefined ) {
                            setdateError(true)
                            setDateErrorMsg('Both start date and end date are required.')
                            return 
                        }else {
                            handleApplyFilter(true);
                            setIsFilterOpen(false)
                        }
                    }else {
                        handleApplyFilter(true);
                        setIsFilterOpen(false)
                    }
                    
                }

                } type="button"   id = "apply_filter"  class="aply-fltr-btn">Apply Filter(s)
                </button>
            </div>
        </div> 
    );
}

export default memo(Filter);
